var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5621 9.45739C18.4857 9.50195 16.6671 10.4425 16.6671 12.5279C16.7528 14.9061 18.9621 15.7401 19 15.7401C18.9621 15.7847 18.6665 16.8763 17.7907 18.0205C17.0956 19.0062 16.3242 20 15.1528 20C14.0385 20 13.6385 19.3431 12.3528 19.3431C10.972 19.3431 10.5813 20 9.5242 20C8.35277 20 7.52419 18.953 6.79127 17.9766C5.8391 16.6986 5.02978 14.6931 5.00121 12.7675C4.98195 11.7471 5.19189 10.744 5.72481 9.89206C6.47699 8.70265 7.81985 7.89524 9.28631 7.86862C10.4099 7.83331 11.4099 8.58747 12.0956 8.58747C12.7528 8.58747 13.9814 7.86862 15.3714 7.86862C15.9714 7.86919 17.5714 8.03762 18.5621 9.45739ZM12.0006 7.66488C11.8006 6.73303 12.3528 5.80119 12.8671 5.20677C13.5242 4.48792 14.5621 4 15.4571 4C15.5143 4.93185 15.1522 5.84575 14.505 6.51136C13.9242 7.23021 12.9242 7.77138 12.0006 7.66488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIcon);
export default __webpack_public_path__ + "static/media/app-store-icon.8577aed432b9b183d7b8935d7b5e0bc0.svg";
export { ForwardRef as ReactComponent };